/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Sdt_ExInputs */

const vi_station_voice_ph_sdt_ex = /** @type {(inputs: Station_Voice_Ph_Sdt_ExInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0901 đọc thành không chín không một`)
};

/**

* @param {Station_Voice_Ph_Sdt_ExInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_sdt_ex = /** @type {((inputs?: Station_Voice_Ph_Sdt_ExInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Sdt_ExInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_sdt_ex(inputs)
});